if (!customElements.get('promotion-image-card')) {
  customElements.define('promotion-image-card', class extends HTMLElement {
    connectedCallback() {
      this.grid = this.closest('.card-grid');
      if (!this.grid) return;
      this.desktop = window.matchMedia('(min-width: 1024px)');
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.updateHeight();
        });
      };
      this.resizeObserver = new ResizeObserver(this.schedule);
      this.observeCards = () => {
        this.resizeObserver.disconnect();
        this.resizeObserver.observe(this.grid);
        this.resizeObserver.observe(this);
        this.grid.querySelectorAll('.product-card:not(.product-card--promo), .product-card__title').forEach(element => this.resizeObserver.observe(element));
      };
      this.observeCards();
      this.mutationObserver = new MutationObserver(() => {
        this.observeCards();
        this.schedule();
      });
      this.mutationObserver.observe(this.grid, { childList: true, subtree: true });
      this.desktop.addEventListener('change', this.schedule);
      document.fonts.ready.then(() => { if (this.isConnected) this.schedule(); });
      this.schedule();
    }
    updateHeight() {
      if (!this.desktop.matches) {
        this.style.removeProperty('--promotion-image-height');
        this.style.removeProperty('--promotion-canvas-height');
        return;
      }
      const bounds = this.getBoundingClientRect();
      if (!bounds.width || !bounds.height) return;
      const cards = Array.from(this.grid.querySelectorAll(':scope > .product-card:not(.product-card--promo)')).map(element => {
        const rect = element.getBoundingClientRect();
        const title = element.querySelector('.product-card__title');
        if (!title || !rect.width || !rect.height) return null;
        const range = document.createRange();
        range.selectNodeContents(title);
        const firstLine = Array.from(range.getClientRects()).find(line => line.width > 0 && line.height > 0);
        if (!firstLine) return null;
        return { rect, titleFirstLineBottom: firstLine.bottom };
      }).filter(Boolean);
      if (!cards.length) return;
      const overlapping = cards.filter(card => card.rect.top >= bounds.top - 2 && card.rect.top < bounds.bottom - 2);
      const lastRow = overlapping.length ? Math.max(...overlapping.map(card => card.rect.top)) : null;
      const candidates = lastRow === null ? cards : overlapping.filter(card => Math.abs(card.rect.top - lastRow) < 2);
      candidates.sort((a, b) => {
        const distance = card => lastRow === null
          ? Math.abs(card.rect.top - bounds.top)
          : Math.abs(card.rect.left + card.rect.width / 2 - bounds.left - bounds.width / 2);
        return distance(a) - distance(b);
      });
      const reference = candidates[0];
      const titleLine = reference.titleFirstLineBottom;
      const target = lastRow === null
        ? bounds.height - (reference.rect.bottom - titleLine)
        : titleLine - bounds.top;
      const height = Math.max(1, Math.min(bounds.height, target));
      const write = (name, value) => {
        const next = value.toFixed(2) + 'px';
        if (this.style.getPropertyValue(name) !== next) this.style.setProperty(name, next);
      };
      write('--promotion-image-height', height);
      write('--promotion-canvas-height', bounds.height);
    }
    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.mutationObserver?.disconnect();
      this.desktop?.removeEventListener('change', this.schedule);
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
  });
}
